<template>
  <div class="analysis-box">
    <a-card :bordered="false">
      <div class="analysis-content">
        <a-row>
          <a-col :span="6">
            <div class="title">今天TOP10访问IP</div>
            <a-table
              :columns="columnsIp"
              :dataSource="data.top_ip"
              :pagination="false"
              :rowKey="menuList => menuList.ip"
              size="small"
            ></a-table>
          </a-col>
          <a-col :span="6" :offset="1">
            <div class="title">今天TOP10访问号</div>
            <a-table
              :columns="columnsHao"
              :dataSource="data.top_hao"
              :pagination="false"
              :rowKey="menuList => menuList.hao"
              size="small"
            ></a-table>
          </a-col>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>
import { Dashboard_query } from "@/api/dashboard";
const columnsIp = [
  {
    title: "IP",
    dataIndex: "ip"
  },
  {
    title: "数量",
    dataIndex: "count"
  }
];
const columnsHao = [
  {
    title: "hao",
    dataIndex: "hao"
  },
  {
    title: "数量",
    dataIndex: "count"
  }
];
export default {
  data() {
    return {
      data: {},
      columnsIp,
      columnsHao
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo: function() {
      Dashboard_query()
        .then(response => {
          this.data = response.res;
          console.log(this.data);
        })
        .catch(() => {});
    }
  },
  beforeDestroy() {},
  components: {}
};
</script>

<style lang="less" scoped>
.analysis-box {
  .title {
    line-height: 30px;
    text-align: center;
    font-weight: 600;
  }
  .ant-table-thead > tr > th {
    padding: 2px 2px;
  }
  .ant-table-tbody > tr > td {
    padding: 2px 2px;
  }
}
</style>
